import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsCard } from '@frontend/ui/card';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';

import { NoPrizeComponent } from '../../../common/common-results/no-prize/no-prize.component';
import { ResultsPrizeGroupComponent } from '../../../common/common-results/results-prize-group/results-prize-group.component';
import { ResultsContent } from '../../../common/models/results/results-content';
import { commonContentMessages, resultsContent, resultsPrizesLength } from '../../../common/store/target-promotion.selectors';
import { PlayerActivityDetails } from '../../models/player-activity-details';
import { isMyProgressDisabled, showCheckButton, singleSlabPromo } from '../../store/player-activity.selectors';

interface CurrentlyAchievedViewModel {
    havePrizesBeenAwarded: boolean;
    showCheckButton: boolean;
    commonContentMessages: { [key: string]: string };
    currentlyAchievedText: string;
    slabType: boolean;
    resultsContent: ResultsContent;
}

@Component({
    selector: 'player-activity-currently-achieved',
    templateUrl: './player-activity-currently-achieved.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, ResultsPrizeGroupComponent, NoPrizeComponent, DsCard],
})
export class PlayerActivityCurrentlyAchievedComponent {
    resultsContent$ = this.store.select(resultsContent);
    isMyProgressDisabled$ = this.store.select(isMyProgressDisabled);
    singleSlabPromo = this.store.select(singleSlabPromo);
    vm$ = combineLatest([
        this.store.select(resultsPrizesLength),
        this.store.select(showCheckButton),
        this.resultsContent$,
        this.store.select(commonContentMessages),
        this.singleSlabPromo,
    ]).pipe(
        map(([resultsPrizesLength, showCheckButton, resultsContent, commonContentMessages, singleSlabPromo]) => {
            if (
                resultsPrizesLength !== undefined &&
                showCheckButton !== undefined &&
                resultsContent !== undefined &&
                commonContentMessages !== undefined &&
                singleSlabPromo !== undefined
            ) {
                return {
                    havePrizesBeenAwarded: resultsPrizesLength > 0,
                    showCheckButton,
                    currentlyAchievedText: resultsContent.currentlyAchievedText,
                    commonContentMessages,
                    slabType: singleSlabPromo,
                    resultsContent,
                } as CurrentlyAchievedViewModel;
            }
            return {} as CurrentlyAchievedViewModel;
        }),
    );

    dsComponents: DSComponents;

    constructor(
        private store: Store<{ playerActivityModuleData: PlayerActivityDetails }>,
        private designSystemHelperService: DesignSystemHelperService,
    ) {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
    }
}
